import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import ButtonTable from '../common/table/buttonTable';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import DateFormat from '../common/dateFormat/DateFormat';
import ManutencaoPreventiva from '../manutencaoPreventiva/manutencaoPreventiva';

import { setModoTela, initForm, alterarManutencaoItem } from './manutencaoActions';

class ManutencaoForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
	
							<Field
								name='id_tipo'
								component={Select}
								options={this.props.listaTipo}
								label='Tipo'
								cols='12 12 12 12'
								placeholder='Selecione o tipo'
								readOnly={readOnly} />

							<Field
								name='id_veiculo'
								component={Select}
								options={this.props.listaVeiculo}
								label='Veículo'
								cols='12 12 12 12'
								placeholder='Selecione o veículo'
								readOnly={readOnly} />
								
							<Field
								name='id_oficina'
								component={Select}
								options={this.props.listaOficina}
								label='Oficina'
								cols='12 12 12 12'
								placeholder='Selecione a oficina'
								readOnly={readOnly} />

							<Field
								name='os'
								component={LabelAndInput}
								label='Ordem de Serviço' placeholder='Informe a OS'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='descricao'
								component={LabelAndInput}
								label='Descrição do Problema' placeholder='Informe a descrição'
								cols='12 12 12 12'
								readOnly={readOnly} />
							
							<Field
								name='datahora_agendamento'
								component={LabelAndInputDateTime}
								label='Agendamento' placeholder='Informe a agendamento'
								cols='12 6 4 4'
								readOnly={readOnly} />
								
							<Field
								name='datahora_previsao'
								component={LabelAndInputDateTime}
								label='Previsão de Término' placeholder='Informe a previsão'
								cols='12 6 4 4'
								readOnly={readOnly} />
						
						</Row>
						{this.props.listaItem.length > 0 &&
						<Content>
							<ContentCard 
								style={{
									backgroundColor: '#f0faf4',
									border: '1px solid #f0faf4'
								}}>
								<ContentCardHeader
									style={{
										backgroundColor: '#add9bf'
									}}>
									<Row>
										<Grid cols='12 12 12 12'>
											<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
												<h6>Reportes</h6>
											</div>
										</Grid>
									</Row>
								</ContentCardHeader>
								<ContentCardBody>
									<Table responsive>
										<THead>
											<Tr>
												<Th width={10}></Th>
												<Th width={10} alignCenter>Data</Th>
												<Th width={100} alignCenter>Veículo</Th>
												<Th width={100} alignCenter>Tipo do Veículo</Th>
												<Th width={100} alignCenter>Unidade</Th>
												<Th width={100} alignCenter>Manutenção</Th>
												<Th width={300} alignCenter>Descrição</Th>
												<Th width={100} alignCenter>Dias em Aberto</Th>						
											</Tr>
										</THead>
										<TBody>
											{this.props.listaItem.map(item => (
												<Tr key={item.id}>
													<Td alignRight minWidth={10}>
														<ButtonTable
															type={'secondary'}
															icon={item.id_manutencao ? 'fas fa-check' : 'fas fa-square-full'}
															visible={true}
															event={() => {
																this.props.alterarManutencaoItem({
																	...item,
																	id_manutencao: item.id_manutencao ? null : this.props.formularioValues.id
																}, this.props.formularioValues.id);
															}} />
													</Td>
													<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
													<Td alignCenter>{item.placa_veiculo}</Td>
													<Td alignCenter>{item.nome_tipo}</Td>
													<Td alignCenter>{item.nome_unidade}</Td>
													<Td alignCenter>{item.nome_manutencao_area}</Td>
													<Td alignCenter>{item.descricao}</Td>
													<Td alignCenter>{item.dias_aberto == 0 ? 'Hoje' : (item.dias_aberto == 1 ? 'ontem' : `${item.dias_aberto} dias`)}</Td>
												</Tr>
											))}
										</TBody>
									</Table>
								</ContentCardBody>
							</ContentCard>
						</Content>}
						
						{!!this.props.formularioValues.id &&
						<ManutencaoPreventiva id_veiculo={this.props.formularioValues.id_veiculo} />}

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text={this.props.formularioValues.iniciar ? 'Iniciar' : (this.props.formularioValues.finalizar ? 'Finalizar' : 'Salvar')}
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

ManutencaoForm = reduxForm({form: 'manutencaoForm', destroyOnUnmount: false})(ManutencaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.manutencao,
	formularioValues: getFormValues('manutencaoForm')(state),
	registro: state.manutencao.registro,
	listaTipo: state.manutencao.listaTipo,
	listaOficina: state.manutencao.listaOficina,
    listaVeiculo: state.manutencao.listaVeiculo,
	listaItem: state.manutencao.listaItem
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, alterarManutencaoItem }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ManutencaoForm);
